var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('WalletBalance',{attrs:{"wallet":_vm.currentWallet}}),(_vm.isInfluencer)?_c('WalletBalance',{attrs:{"wallet":_vm.otherWallet}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }